import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { forEach } from 'lodash';
import { getPollStep } from '../../../common/utils/live-poll';
import { isReadyLiveStream, isPendingLiveStream } from '../../../common/ui-selectors/video/live';
class LivePolling extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "timeouts", []);
    _defineProperty(this, "pollVideo", videoItem => {
      const {
        getVideoData
      } = this.props;
      const {
        id
      } = videoItem;
      const step = getPollStep(videoItem);
      if (!step) {
        return;
      }
      getVideoData(id).then(this.onPollResponse).then(changedVideoItem => this.checkStatusChange(videoItem, changedVideoItem)).then(this.handleStatusChange).then(changedVideoItem => {
        if (changedVideoItem) {
          this.timeouts[id] = setTimeout(() => this.pollVideo(changedVideoItem), step);
        }
      }).catch(e => this.onPollResponse({
        data: videoItem
      }, e));
    });
    _defineProperty(this, "onPollResponse", (response, error) => {
      const {
        data
      } = response;
      this.props.onPoll(data, error);
      return data;
    });
    _defineProperty(this, "checkStatusChange", (videoItem, changedVideoItem) => {
      const {
        onStreamChangePending,
        onStreamChangeReady
      } = this.props;
      let changedVideoItemWithPaymentInfo = videoItem;
      if (!changedVideoItem) {
        return {
          ready: false,
          changedVideoItem: changedVideoItemWithPaymentInfo
        };
      }
      if (!isPendingLiveStream(videoItem) && isPendingLiveStream(changedVideoItem)) {
        changedVideoItemWithPaymentInfo = {
          ...changedVideoItem,
          dgsInfo: videoItem.dgsInfo
        };
        onStreamChangePending(changedVideoItemWithPaymentInfo);
        return {
          ready: false,
          changedVideoItem: changedVideoItemWithPaymentInfo
        };
      }
      if (!isReadyLiveStream(videoItem) && isReadyLiveStream(changedVideoItem)) {
        changedVideoItemWithPaymentInfo = {
          ...changedVideoItem,
          dgsInfo: videoItem.dgsInfo
        };
        onStreamChangeReady(changedVideoItemWithPaymentInfo);
        return {
          ready: true,
          changedVideoItem: changedVideoItemWithPaymentInfo
        };
      }
      return {
        ready: false,
        changedVideoItem: changedVideoItemWithPaymentInfo
      };
    });
    _defineProperty(this, "handleStatusChange", status => {
      const {
        autoplayVideo
      } = this.props;
      const {
        ready,
        changedVideoItem
      } = status;
      if (ready && changedVideoItem) {
        autoplayVideo(changedVideoItem);
        return null;
      }
      return status.changedVideoItem;
    });
  }
  componentDidMount() {
    const {
      scheduledVideos,
      pendingVideos
    } = this.props;
    forEach(scheduledVideos, this.pollVideo);
    forEach(pendingVideos, this.pollVideo);
    this.handleInitialStreaming();
  }
  componentWillUnmount() {
    forEach(this.timeouts, timeoutId => clearTimeout(timeoutId));
  }
  handleInitialStreaming() {
    const {
      streamingVideos,
      canInitiallyAutoplay
    } = this.props;
    const firstStreaming = streamingVideos && streamingVideos[0];
    if (firstStreaming && canInitiallyAutoplay(firstStreaming.id)) {
      this.props.autoplayVideo(firstStreaming);
    }
  }
  render() {
    return null;
  }
}
export default LivePolling;
//# sourceMappingURL=live-polling.js.map